module.exports = __webpack_public_path__ + "empty_msg.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/empty_msg.png
// module id = 2185
// module chunks = 13